import { useState, useEffect } from "react";

// Components
import Text from "components/common/Text";
import HPItem from "./HPItem";
import Carousel from "components/common/Carousel";

// Libs
import Translation from "libs/Translation";

const ClinicInfo = ({ doctor }) => {
  const [select, setSelect] = useState(
    doctor.HealthProviderProfiles?.length &&
      doctor.HealthProviderProfiles[0].HealthProvider
  );
  const [HP, setHP] = useState(
    doctor.HealthProviderProfiles?.length && doctor.HealthProviderProfiles[0]
  );

  useEffect(() => {
    const s = doctor.HealthProviderProfiles?.filter(
      (h) => h.HealthProvider === select
    );
    s?.length && setHP(s[0]);
  }, [select]);

  useEffect(() => {
    if (doctor.HealthProviderProfiles?.length) {
      setHP(doctor.HealthProviderProfiles[0]);
      setSelect(doctor.HealthProviderProfiles[0].HealthProvider);
    }
  }, [doctor]);

  const handleSelect = (id) => {
    setSelect(id);
  };

  return (
    <div className="carousel">
      <Carousel
        id="healthProviders"
        items={doctor.HealthProviderProfiles}
        gap={20}
        arrowOnDesktop={false}
        arrowButtonShadow={false}
        renderItem={(item) => (
          <HPItem
            id="clinic-info"
            selected={select}
            onClick={handleSelect}
            {...item}
          />
        )}
      />
      <div className="content">
        {HP?.Address && (
          <div className="clinic-info">
            <div className="row-flex gap-5">
              <img
                alt="location-icon"
                src="/nextasset/images/doctorProfile/pin.svg"
                width={18}
                height={18}
              />
              <Text tag="span" className="label">
                {Translation.t("label.address")}
              </Text>
            </div>
            <Text tag="h3" className="value">
              {Translation.n(HP?.Address)}
            </Text>
          </div>
        )}
        {HP?.phoneNumber && (
          <div className="clinic-info">
            <div className="row-flex gap-5">
              <img
                alt="telephone-icon"
                src="/nextasset/images/doctorProfile/call.svg"
                width={18}
                height={18}
              />
              <Text tag="span" className="label">
                {Translation.t("label.phone-number")}
              </Text>
            </div>
            <Text tag="h3" className="value">
              {Translation.n(HP?.phoneNumber)}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};
export default ClinicInfo;
